module.exports = __webpack_public_path__ + "img/waiting-round-icon.cb46ce4f.svg";